import VerificationDialog from "./VerificationDialog";

export default VerificationDialog;
